import React from 'react';
import { styled } from 'styled-components';
import SvgChevron from '../../../../play-core/icons/Chevron';
import SvgFilter from '../../../../play-core/icons/Filter';
import { Colors } from '../../../../play-core/styles/Colors';
import { ActionIcon } from '../Dropdown/DropdownButton';
import { IconTextWrapper } from '../IconText/IconTextWrapper';
import { LoadingBar } from '../LoadingBar/LoadingBar';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DateFilterButton = ({
  text,
  onClick,
  isOpen,
  isLoading,
  alwaysOpen
}) => /*#__PURE__*/_jsxs(StyledDateFilterButton, {
  onClick: onClick,
  isOpen: isOpen,
  children: [/*#__PURE__*/_jsx(LoadingBar, {
    isLoading: isLoading
  }), /*#__PURE__*/_jsxs(ButtonWrapper, {
    children: [/*#__PURE__*/_jsx(IconTextWrapper, {
      icon: /*#__PURE__*/_jsx(SvgFilter, {}),
      text: text,
      fontSize: {
        mediaQuery: [],
        default: 16
      },
      spaceBetween: 10
    }), !alwaysOpen && /*#__PURE__*/_jsx(ActionIcon, {
      isOpen: isOpen,
      children: /*#__PURE__*/_jsx(SvgChevron, {
        orientation: "down"
      })
    })]
  })]
});
const StyledDateFilterButton = styled.button.withConfig({
  displayName: "DateFilterButton__StyledDateFilterButton",
  componentId: "sc-1bqw6tv-0"
})(["position:relative;min-width:222px;width:100%;height:48px;padding-left:12px;padding-right:12px;color:", ";background-color:", ";&:hover{background-color:", ";}"], Colors.GREY_d2d2d2, ({
  isOpen
}) => isOpen ? Colors.GREY_454545 : 'transparent', Colors.GREY_454545);
const ButtonWrapper = styled.div.withConfig({
  displayName: "DateFilterButton__ButtonWrapper",
  componentId: "sc-1bqw6tv-1"
})(["display:flex;align-items:center;justify-content:space-between;"]);